import { AbstractEntity } from '../AbstractEntity'

export class ContractNoPriceSurchargeFcl extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get contractNoPriceUuid() {
    return this._data.contractNoPriceUuid
  }
  set contractNoPriceUuid(contractNoPriceUuid) {
    this._data.contractNoPriceUuid = contractNoPriceUuid
  }
  get receivable() {
    return this._data.receivable
  }
  set receivable(receivable) {
    this._data.receivable = receivable || false
  }
  get chargeType() {
    return this._data.chargeType
  }
  set chargeType(chargeType) {
    this._data.chargeType = chargeType
  }
  get chargeScaleCode() {
    return this._data.chargeScaleCode
  }
  set chargeScaleCode(chargeScaleCode) {
    this._data.chargeScaleCode = chargeScaleCode
  }
  get unit() {
    return this._data.unit
  }
  set unit(unit) {
    this._data.unit = unit
  }
  get vat() {
    return this._data.vat
  }
  set vat(vat) {
    this._data.vat = vat || false
  }
  get taxRate() {
    return this._data.taxRate
  }
  set taxRate(taxRate) {
    this._data.taxRate = taxRate || 0
  }
  get sum20() {
    return this._data.sum20
  }
  set sum20(sum20) {
    this._data.sum20 = sum20 || 0
  }
  get sum40() {
    return this._data.sum40
  }
  set sum40(sum40) {
    this._data.sum40 = sum40 || 0
  }
  get sumHc() {
    return this._data.sumHc
  }
  set sumHc(sumHc) {
    this._data.sumHc = sumHc || 0
  }
  get sum45() {
    return this._data.sum45
  }
  set sum45(sum45) {
    this._data.sum45 = sum45 || 0
  }
  get casePrice() {
    return this._data.casePrice
  }
  set casePrice(casePrice) {
    this._data.casePrice = casePrice || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get payment() {
    return this._data.payment
  }
  set payment(payment) {
    this._data.payment = payment
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get dangerous() {
    return this._data.dangerous
  }
  set dangerous(dangerous) {
    this._data.dangerous = dangerous || false
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get manualAdded() {
    return this._data.manualAdded
  }
  set manualAdded(manualAdded) {
    this._data.manualAdded = manualAdded || false
  }
}
